import { chartGlobalLabelDefaults } from '@/constants/chart-global-styles.constants'

export default {
  id: 'donuthole-chart-label-plugin',
  defaults: {
    style: chartGlobalLabelDefaults.style
  },
  beforeDraw: function (chart) {
    let width = chart.chart.width
    let height = chart.chart.height
    let ctx = chart.chart.ctx
    ctx.restore()

    let styles = _.clone(this.defaults.style)

    if (chart.options.plugins['donuthole-chart-label-plugin']) {
      _.merge(styles, chart.options.plugins['donuthole-chart-label-plugin'].style)
    }

    // filled circle
    ctx.beginPath()
    ctx.fillStyle = styles.circleFillColor

    let paddingOffset = chart.options.layout.padding.top - chart.options.layout.padding.bottom * 0.5
    let yOffset = chart.offsetY + paddingOffset // yoffset > 0 if donut circumference < 2*Pi
    let radius = chart.innerRadius * (chart.options.cutoutPercentage / 100)
    ctx.arc(width / 2, height / 2 + yOffset, radius, 0, 2 * Math.PI) // context.arc(x,y,r,sAngle,eAngle,counterclockwise(op));
    ctx.fill()

    // if no text, skip
    if (!chart.data.centerDonutTitle) {
      ctx.save()
      return true
    }

    // dwelling days text
    let text = chart.data.centerDonutTitle
    let size = 52 * (6 / (text[0].length + 5))
    ctx.beginPath()
    ctx.textBaseline = styles.textBaseline
    ctx.textAlign = styles.textAlign
    ctx.fillStyle = 'rgba(0, 0, 0, 0.75)'
    ctx.font = `${size}px ${styles.fontFamily}`
    ctx.fillText(text[0].toUpperCase(), width / 2, height / 2 + yOffset)
    ctx.font = `8px ${styles.fontFamily}`
    ctx.fillText(
      text[1]
        .toUpperCase()
        .split('')
        .join(' '),
      width / 2,
      height / 2 + yOffset + size / 2 + 2
    )
    ctx.fill()

    ctx.save()
  }
}



// WEBPACK FOOTER //
// ./src/components/chart/plugins/donuthole-chart-label.plugin.js